<template>
  <el-card class="menuBody" style="width: 100%;" shadow="never">
    <left-floor-tree @chooseNode="selectNode"></left-floor-tree>
        <el-card>
            <el-row >
                <div class="search-title">
                    仪表详情
                </div>
                <div class="search-input-item">
                    <el-input size="small" v-model="query.payMeterNo" placeholder="请输入表号" clearable></el-input>
                </div>
                <div class="search-input-item">
                    <el-input size="small" v-model="query.actualNo" placeholder="请输入实际表号" clearable></el-input>
                </div>
                <div class="search-input-item">
                    <el-input size="small" v-model="query.mainNo" placeholder="请输入主表号" clearable></el-input>
                </div>
                <div class="search-input-item">
                    <el-input size="small" v-model="query.roomName" placeholder="请输入房间号" clearable></el-input>
                </div>
                <div class="search-input-item">
                    <el-select  clearable size="small" v-model="query.meterType" placeholder="仪表类型" >
                        <el-option v-for="item in meterType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="search-input-item">
                    <el-select  clearable size="small" v-model="query.useStatus" placeholder="使用状态" >
                    <el-option v-for="item in useStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="search-input-item">
                    <el-select  clearable size="small" v-model="query.billingFlag" placeholder="是否计费" >
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="search-input-item">
                    <el-select  clearable size="small" v-model="query.autoFlag" placeholder="是否智能表" >
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
              <div class="search-input-item">
                    <el-select  clearable size="small" v-model="query.dummyFlag" placeholder="是否虚拟表" >
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="search-input-item">
                    <el-select  clearable size="small" v-model="query.outReadDateDays" placeholder="读表超时" >
                        <el-option v-for="item in readTimeout" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="search-input-item">
                    <el-select  clearable size="small" v-model="query.openClose" placeholder="通断状态" >
                        <el-option v-for="item in openCloseStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="search-input-item">
                    <el-select  clearable size="small" v-model="query.bindFee" placeholder="物业费绑定状态" >
                        <el-option v-for="item in bindFeeStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="search-input-item">
                    <el-select  clearable size="small" v-model="query.searchRemainUse" placeholder="预警额度" >
                        <el-option v-for="item in warnThreshod" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="search-input-item">
                    <el-select  clearable size="small" v-model="query.isPublic" placeholder="是否公共区域" >
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>

                <div class="search-button-tools">
                    <el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.detail.listPage'" :loading="tableLoading" @click="doSearch">查询</el-button>
                    <el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.detail.export'" v-debounce @click="doExport">导出</el-button>
                    <el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.detail.changeOnOff'" :disabled="disableMulAction" @click="doOpenChangeOnOff">更改通断模式</el-button>
                    <el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.detail.updateOpenClose'" :loading="updateOpenCloseButtonLoading" :disabled="disableMulAction" @click="doUpdateOpenClose">更新通断状态</el-button>
                    <el-button size="small" type="primary" v-Jurisdiction="'hydropower.web.charge.detail.updateDegrees'" :loading="updateDegreeButtonLoading" :disabled="disableMulAction" @click="doUpdateDegree">更新读数</el-button>
                </div>
                <el-table  
                :data="tableData"  
                @selection-change="handleSelectionChange" 
                row-key="id" 
                border
                v-loading="tableLoading"
                tooltip-effect="light"
                :stripe="true">
                    <el-table-column width="55" fixed="left" type="selection"></el-table-column>
                    <el-table-column width="250" prop="payMeterNo" label="表号" align="left">
                      <template slot-scope="scope">
                        <el-button v-Jurisdiction="'hydropower.web.charge.detail.listUseData'" @click="doLookUsePage(scope.row)" type="text" size="small">用量</el-button>
                        <span>{{scope.row.payMeterNo}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="200" show-overflow-tooltip prop="actualNo" label="实际表号"></el-table-column>
                    <el-table-column width="100" show-overflow-tooltip prop="mainNo" label="主表号"></el-table-column>
                    <el-table-column width="100" prop="meterType" label="类型"></el-table-column>
                    <el-table-column width="200" show-overflow-tooltip prop="projectName" label="项目小区"></el-table-column>
                    <el-table-column width="150" show-overflow-tooltip prop="floorName" label="楼栋"></el-table-column>
                    <el-table-column width="150" show-overflow-tooltip prop="roomName" label="房间号"></el-table-column>

                    <el-table-column width="200" show-overflow-tooltip prop="roomCusName" label="业主名"></el-table-column>
                    <el-table-column width="120" prop="price" label="单价" align="right"></el-table-column>
                    <el-table-column width="180" prop="payAmount" label="累计缴费" align="right">
                      <template slot-scope="scope">
                        {{scope.row.payAmount}}
                        <el-button v-Jurisdiction="'hydropower.web.charge.detail.listUseData'" @click="doLookChargeRecordPage(scope.row)" type="text" size="small">详情</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column width="150" prop="payUse" label="累计充值度数/吨数" align="right"></el-table-column>
                    <el-table-column width="150" prop="dregree7" label="初始使用度数/吨数" align="right"></el-table-column>
                    <el-table-column width="150" prop="totalUse" label="累计使用度数/吨数" align="right"></el-table-column>
                    <el-table-column width="150" prop="remainUse" label="剩余度数/吨数" align="right"></el-table-column>
                    <el-table-column width="150" prop="remainAmount" label="剩余金额" align="right">
                        <template slot-scope="scope">
                            {{scope.row.remainAmount}}
                            <el-button v-Jurisdiction="'hydropower.web.charge.detail.onRemainAmount'" @click="doLookRemainAmountPage(scope.row)" type="text" size="small">详情</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column width="100" prop="useStatusStr" label="使用状态" align="right"></el-table-column>
                    <el-table-column width="120" prop="bindStatusStr" label="绑定状态" align="right">
                      <template slot-scope="scope">
                          <span>{{scope.row.bindStatusStr}}</span>
                          <el-button v-if="scope.row.bindStatus == 0" @click="doSaveBindFee(scope.row.id, 1)" type="text" size="small" v-Jurisdiction="'hydropower.web.charge.detail.bindFeeSave'">绑定</el-button>
                          <el-button v-if="scope.row.bindStatus == 1" @click="doSaveBindFee(scope.row.id, 0)" type="text" size="small" v-Jurisdiction="'hydropower.web.charge.detail.bindFeeSave'">解绑</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column width="100" prop="openCloseStr" label="通断状态">
                      <template slot-scope="scope">
                          <span v-if="scope.row.openClose == 1" style="color: green">{{scope.row.openCloseStr}}</span>
                          <span v-if="scope.row.openClose == 30" style="color: gray">{{scope.row.openCloseStr}}</span>
                          <span v-if="scope.row.openClose == 2" style="color: red">{{scope.row.openCloseStr}}</span>
                          <span v-if="scope.row.openClose == 31" style="color: gray">{{scope.row.openCloseStr}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="180" prop="onOffStr" label="通断模式">
                      <template slot-scope="scope">
                        <el-button v-Jurisdiction="'hydropower.web.charge.detail.changeOnOff'" @click="doOpenChangeOnOff(scope.row)" type="text" size="small">{{scope.row.onOffStr}}</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column width="180" prop="readDate" label="最后读表时间"></el-table-column>
                    <el-table-column width="300" fixed="right" label="操作" >
                    <template slot-scope="scope">
                        <el-button v-Jurisdiction="'hydropower.web.charge.detail.offlineCharge'" v-if="scope.row.bindStatus == 1 && scope.row.useStatus == 0" @click="doLookOfflineChargePage(scope.row)" type="text" size="small">充值</el-button>
                        <el-button v-Jurisdiction="'hydropower.web.charge.detail.changeOpenClose'" v-if="scope.row.autoFlag == 1 && scope.row.onOff != 2" v-debounce @click="doChangeOpenClose(scope.row.id, 'close')" type="text" size="small">断电</el-button>
                        <el-button v-Jurisdiction="'hydropower.web.charge.detail.changeOpenClose'" v-if="scope.row.autoFlag == 1 && scope.row.onOff != 2" v-debounce @click="doChangeOpenClose(scope.row.id, 'open')" type="text" size="small">送电</el-button>
                        <el-button v-Jurisdiction="'hydropower.web.charge.detail.openCloseRecords'" v-if="scope.row.autoFlag == 1" @click="doLookOpenCloseRecordPage(scope.row)" type="text" size="small">通断详情</el-button>
                        <el-button v-Jurisdiction="'hydropower.web.charge.detail.listPageUseData'" v-if="scope.row.autoFlag == 1" @click="doLookUseRecordPage(scope.row)" type="text" size="small">用量详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <p style="color: red">剩余金额合计: {{remainInfo.remainAmount}}</p>
                <simple-pagination @search="doSearch" />
            </el-row>
    </el-card>
    <el-dialog
      :title="onOffDlg.title"
      :visible.sync="onOffDlg.visible"
      v-if="onOffDlg.visible"
      :destroy-on-close="true"
      center
      width="300px"
      >
          <el-radio-group v-model="onOffDlg.formData.onOff">
            <el-radio :label="0">自动</el-radio>
            <el-radio :label="1">手动</el-radio>
            <el-radio :label="2">不做通断</el-radio>
          </el-radio-group>
          <span slot="footer" class="dialog-footer">
              <el-button size="small" @click="onOffDlg.visible = false">取 消</el-button>
              <el-button size="small" type="primary" :loading="changeOnOffButtonLoading" @click="doChangeOnOffMode">确 定</el-button>
          </span>
      </el-dialog>

      <!-- 仪表使用量图表 -->
      <el-dialog
      :title="useDataDlg.title"
      :visible.sync="useDataDlg.visible"
      v-if="useDataDlg.visible"
      :destroy-on-close="true"
      center
      width="800px"
      >
        <use-data :meterId="useDataDlg.meterId" :payMeterNo="useDataDlg.payMeterNo"></use-data>
      </el-dialog>

      <!-- 缴费记录 -->
      <el-dialog
      :title="payRecordDlg.title"
      :visible.sync="payRecordDlg.visible"
      v-if="payRecordDlg.visible"
      :destroy-on-close="true"
      center
      width="420px"
      >
        <charge-record :meterId="payRecordDlg.meterId"></charge-record>
      </el-dialog>

      <!-- 剩余额度 -->
      <el-dialog
      :title="remainAmountInfoDlg.title"
      :visible.sync="remainAmountInfoDlg.visible"
      v-if="remainAmountInfoDlg.visible"
      center
      width="520px"
      >
        <remain-amount-info :meterId="remainAmountInfoDlg.meterId"></remain-amount-info>
      </el-dialog>

      <!-- 线下充值 -->
      <el-dialog
      :title="offlineChargeDlg.title"
      :visible.sync="offlineChargeDlg.visible"
      v-if="offlineChargeDlg.visible"
      :destroy-on-close="true"
      width="820px"
      center
      >
        <offline-charge-form :meterId="offlineChargeDlg.meterId" @search="doSearch" @after="openInvoice"></offline-charge-form>
      </el-dialog>

      <!-- 通断详情 -->
      <el-dialog
      :title="openCloseDetailTableDlg.title"
      :visible.sync="openCloseDetailTableDlg.visible"
      v-if="openCloseDetailTableDlg.visible"
      :destroy-on-close="true"
      width="90%"
      center
      >
        <open-close-detail-table :meterId="openCloseDetailTableDlg.meterId"></open-close-detail-table>
      </el-dialog>

    
      <!-- 用量详情 -->
      <el-dialog
      :title="useDataDetailTableDlg.title"
      :visible.sync="useDataDetailTableDlg.visible"
      v-if="useDataDetailTableDlg.visible"
      :destroy-on-close="true"
      width="80%"
      center
      >
        <use-data-detail-table :payMeterNo="useDataDetailTableDlg.payMeterNo"></use-data-detail-table>
      </el-dialog>

      <el-dialog :title="invoiceDlg.title" :visible.sync="invoiceDlg.visible" v-if="invoiceDlg.visible" width="88%" :destroy-on-close="true">
            <invoice :orderId="invoiceDlg.orderId"></invoice>
        </el-dialog>

  </el-card>
</template>
<script>
import '@/assets/scss/common.scss';
import {useStatus, options, meterType, openCloseStatus, readTimeout, bindFeeStatus, warnThreshod} from "@/dict/meterDict";
import mixin from '@/mixin/index';
import { pick, omit, assign } from 'lodash';
import OfflineChargeForm from './components/OfflineChargeForm.vue';
import OpenCloseDetailTable from './components/OpenCloseDetailTable.vue';
import UseDataDetailTable from './components/UseDataDetailTable.vue';
import ChargeRecord from './components/ChargeRecord.vue';
import RemainAmountInfo from './components/RemainAmountInfo.vue';
import UseData from './components/UseData.vue';
import { get, post, alertMultiMessage, alertSingleMessage } from "@/assets/common/request";
import LeftFloorTree from '@/components/LeftFloorTree.vue';
import Invoice from '../order/components/Invoice.vue';
export default {
  name: "MeterDetailIndex",
  mixins: [mixin],
  components: { OfflineChargeForm, OpenCloseDetailTable, UseDataDetailTable, ChargeRecord, RemainAmountInfo, UseData, LeftFloorTree, Invoice },
  data() {
    return {
        useStatus,
        options,
        meterType,
        openCloseStatus,
        readTimeout,
        bindFeeStatus,
        warnThreshod,
        changeOnOffButtonLoading: false,
        updateOpenCloseButtonLoading: false,
        updateDegreeButtonLoading: false,
        queryListUrl: '/meter/web/detail/listPage',
        remainInfo: {},
        onOffDlg: {
          title: '更改通断模式',
          visible: false,
          formData: {onOff: -1}
        },
        useDataDlg: {
          title: '用量详情',
          visible: false,
          meterId: ''
        },
        payRecordDlg: {
          title: '充值记录',
          visible: false,
          meterId: ''
        },
        remainAmountInfoDlg: {
          title: '详情',
          visible: false,
          meterId: ''
        },
        offlineChargeDlg: {
          title: '线下充值',
          visible: false,
          meterId: ''
        },
        openCloseDetailTableDlg: {
          title: '通断详情',
          visible: false,
          meterId: ''
        },
        useDataDetailTableDlg: {
          title: '用量详情',
          visible: false,
          payMeterNo: ''
        },
        invoiceDlg: {
            title: "凭证",
            visible: false,
        },
    }
  },
  methods: {
    doSearch() {
       this.getList();
       this.doSumMeterRemainInfo();
    },
    doSumMeterRemainInfo() {
        const url = 'meter/web/detail/sumPageDetailRemainInfo';
        const params = omit(this.getSearchParams(), ['page', 'size'])
        get(url, params).then(({data}) => {
            this.remainInfo = data || {remainAmount: '0.00元'};
        })
    },
    doExport() {
      const title = '仪表详情数据';
      const url = 'meter/web/detail/export';
      this._export(title, url);
    },
    doOpenChangeOnOff(row) {
      let currentOnOff = -1;
      let canOpen = true;
      if(row instanceof MouseEvent) {
        canOpen = this.checkSelection();
        const ids = this.getSelectionIds();
        this.onOffDlg.formData.ids = ids;
      }else {
        currentOnOff = row.onOff;
        this.onOffDlg.formData.ids = [row.id];
      }
      if(canOpen) {
        this.onOffDlg.visible = true;
        this.onOffDlg.formData.onOff = currentOnOff;
      }
    },
    doChangeOnOffMode() {
      const data = pick(this.onOffDlg.formData, 'onOff', 'ids');
      const url = 'meter/web/detail/changeOnOff';
      this.changeOnOffButtonLoading = true;
      post(url, data).then((data) => {
        this.doSearch();
        this.onOffDlg = {
          title: '更改通断模式',
          visible: false,
          formData: {onOff: -1}
        };
        alertMultiMessage(data, 1000);
      }).finally(() => {
          this.changeOnOffButtonLoading = false;
      });
    },
    doUpdateOpenClose() {
      this.handleSelectionCall(ids => {
        this.updateOpenCloseButtonLoading = true;
        const url = 'meter/web/detail/updateOpenClose';
        post(url, {ids: ids}).then((data) => {
          this.doSearch();
          alertMultiMessage(data, 3000);
        }).finally(() => {
            this.updateOpenCloseButtonLoading = false;
        });
      })
    },
    doUpdateDegree() {
      this.handleSelectionCall(ids => {
        const url = 'meter/web/detail/updateDegrees';
        this.updateDegreeButtonLoading = true;
        post(url, {ids: ids}).then((data) => {
          this.doSearch();
          alertMultiMessage(data, 1000);
        }).then(() => {
            this.updateDegreeButtonLoading = false;
        });
      })
    },
    doLookUsePage(row) {
      this.useDataDlg = { visible: true, meterId: row.id, payMeterNo: row.payMeterNo }
    },
    doLookChargeRecordPage(row) {
      this.payRecordDlg = { visible: true, meterId: row.id }
    },
    doLookRemainAmountPage(row) {
      this.remainAmountInfoDlg = { visible: true, meterId: row.id }
    },
    doLookOfflineChargePage(row) {
      this.offlineChargeDlg = { visible: true, meterId: row.id, unit: row.unit }
    },
    doSaveBindFee(id, bindFee) {
      this.$confirm(`将要${bindFee == 1? '绑定' : '解绑'}物业费, 是否继续?`, '提示', {
          cancelButtonText: '取消',
          confirmButtonText: '确定',
          type: 'warning'
      }).then(() => {
          const url = 'meter/web/detail/bindFeeSave';
          const params = {
            meterId: id,
            bindFee: bindFee
          };
          get(url, params).then((data) => {
            this.doSearch();
            alertSingleMessage(data);
          });
        });
    },
    doChangeOpenClose(id, openCloseStr) {
      const url = 'meter/web/detail/changeOpenClose';
      const data = {
        id: id,
        openCloseStr: openCloseStr
      };
      post(url, data).then((data) => {
        this.doSearch();
        alertSingleMessage(data);
      });
    },
    doLookOpenCloseRecordPage(row) {
      this.openCloseDetailTableDlg = {
        visible: true,
        meterId: row.id
      }
    },
    doLookUseRecordPage(row) {
      this.useDataDetailTableDlg = {
        visible: true,
        payMeterNo: row.payMeterNo
      }
    },
    openInvoice(data) {
        this.invoiceDlg = {
                visible: true,
                title: '凭证',
                orderId: data
            };
    },
    selectNode(data){
        this.query = assign(this.query, data);
        this.doSearch();
    },
  },
  mounted() {
    this.doSearch();
  }
}
</script>
